import { usePortalActiveClinic } from '@/lib/portalActiveClinic';
import { PortalPageHead } from '@/components/portal/PortalChrome';
import { ClinicFallbackMark, PortalIcon } from '@/components/portal/PortalIcon';
import { formatClinicAddress } from '@/lib/portalFormat';

export function PortalClinics() {
  const { clinics, activeClinicId, setActiveClinicId, isLoading } = usePortalActiveClinic();

  return (
    <>
      <PortalPageHead
        title="Klinikker"
        subtitle="Vælg den klinik, du vil se portalen for."
      />
      {isLoading ? (
        <section className="card">
          <p className="help">Henter klinikker…</p>
        </section>
      ) : clinics.length === 0 ? (
        <section className="card">
          <p className="help">Du er ikke tilknyttet en klinik endnu.</p>
        </section>
      ) : (
        <section className="card">
          {clinics.map((clinic) => {
            const active = clinic.clinic_id === activeClinicId;
            return (
              <button
                key={clinic.clinic_id}
                type="button"
                className={`svc-i${active ? ' on' : ''}`}
                aria-pressed={active}
                onClick={() => setActiveClinicId(clinic.clinic_id)}
                style={{ width: '100%', marginTop: 12, textAlign: 'left' }}
              >
                {clinic.clinic_logo ? (
                  <img className="cl-logo" src={clinic.clinic_logo} alt="" />
                ) : (
                  <ClinicFallbackMark />
                )}
                <div className="grow">
                  <div className="t">{clinic.clinic_name}</div>
                  <div className="s">{formatClinicAddress(clinic.clinic_address) || 'Klinik'}</div>
                </div>
                {active ? (
                  <span className="chip chip-teal">
                    <PortalIcon name="check" size="xs" />
                    Aktiv
                  </span>
                ) : null}
              </button>
            );
          })}
        </section>
      )}
    </>
  );
}
